export class DivineControlEvent {
    data;
    constructor() { }
    getData() {
        return this.data;
    }
    setData(data) {
        this.data = data;
        return this;
    }
}
